/**
 * Modales de la Landing 2.0 (ADR 153).
 *
 * Mejora progresiva de verdad: el disparador es un enlace normal que ya lleva su
 * destino real —el WhatsApp de la tienda— y este script lo ASCIENDE a modal. Sin
 * JavaScript, o en un navegador sin `<dialog>`, el clic hace lo de siempre y la
 * persona acaba donde tenía que acabar. Nunca hay un botón muerto.
 *
 * Se usa `<dialog>` y no un div propio porque trae gratis lo que casi siempre se
 * implementa mal: el foco atrapado dentro, Escape para cerrar, el resto de la
 * página inerte para el lector de pantalla y el backdrop como pseudo-elemento.
 */
(function () {
  if (window.vaultModalListo) return;
  window.vaultModalListo = true;

  function panelDe(nombre) {
    return document.querySelector('[data-vault-modal-panel="' + nombre + '"]');
  }

  function abrir(evento) {
    var disparador = evento.currentTarget;
    var panel = panelDe(disparador.dataset.vaultModal);

    /* Sin panel o sin soporte, no se toca el clic: que siga al enlace. */
    if (!panel || typeof panel.showModal !== 'function') return;

    evento.preventDefault();
    panel.showModal();

    /* El fondo no se desplaza mientras el modal está abierto. `<dialog>` no lo
       hace solo, y en móvil es lo que hace que el modal se sienta una capa y no
       un trozo más de la página. */
    document.documentElement.style.overflow = 'hidden';
    panel.addEventListener('close', soltarElFondo, { once: true });

    if (window.vaultEvento) window.vaultEvento('landing_hero_cta', 'modal:' + disparador.dataset.vaultModal);
  }

  function soltarElFondo() {
    document.documentElement.style.overflow = '';
  }

  function arrancar() {
    document.querySelectorAll('[data-vault-modal]').forEach(function (disparador) {
      if (disparador.dataset.vaultModalListo) return;
      disparador.dataset.vaultModalListo = '1';
      disparador.addEventListener('click', abrir);
    });

    /* Clic fuera de la caja = cerrar. El `<dialog>` ocupa toda la pantalla, así
       que "fuera" es el propio dialog y no su contenido: se compara el objetivo
       del clic contra el elemento, que es la forma que funciona sin medir
       coordenadas. */
    document.querySelectorAll('[data-vault-modal-panel]').forEach(function (panel) {
      if (panel.dataset.vaultModalListo) return;
      panel.dataset.vaultModalListo = '1';
      panel.addEventListener('click', function (evento) {
        if (evento.target === panel) panel.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
